import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Grid, Typography } from '../../../mui/Core/index'
import { routePaths } from '../../../../constants/routes'

export function UnauthorizedUser() {
  const navigate = useNavigate()

  const handleRedirectToLogin = () => {
    navigate(routePaths.LOGIN)
  }

  const gridContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    mt: 50,
    alignItems: 'center',
  }

  return (
    <Grid container sx={gridContainerStyle}>
      <Grid>
        <Typography variant='h3'>Unauthorized</Typography>
        <Typography variant='errorMessage' sx={{ mt: 3 }}>
          You are not authorized to view this page.
        </Typography>
        <Typography variant='errorMessage'>
          Please try logging in again or navigating to a different page.
        </Typography>
        <Button variant='contained' onClick={handleRedirectToLogin} sx={{ mt: 5 }}>
          Return to Login
        </Button>
      </Grid>
    </Grid>
  )
}
